import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { Observable } from 'rxjs'
import { ElderDateSwitcherComponent, Interval, TimeUtil } from '@elderbyte/ngx-starter'
import { IntervalContextService } from '../interval-context.service'
import { map } from 'rxjs/operators'
import { LocalDate } from '@js-joda/core'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-interval-context-menu',
  templateUrl: './interval-context-menu.component.html',
  styleUrls: ['./interval-context-menu.component.scss'],
  imports: [ElderDateSwitcherComponent, AsyncPipe],
})
export class IntervalContextMenuComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)
  private intervalContextService = inject(IntervalContextService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    if (!this.intervalContextService.interval) {
      this.activeDate = LocalDate.now()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Getters / Setters                                                       *
   *                                                                         *
   **************************************************************************/

  public get activeDate$(): Observable<Date> {
    return this.intervalContextService.interval$.pipe(
      map((interval) => TimeUtil.date(interval.start))
    )
  }

  public set activeDate(localDate: LocalDate) {
    if (localDate) {
      const interval = Interval.ofDayDate(TimeUtil.localDateToDate(localDate))
      this.intervalContextService.setInterval(interval)
    }
  }
}
